import { isNumeric, prettifyNumber } from 'application/util/number.util';

import './pretty-number.style.sass';
import template from './pretty-number.tpl.pug';

class PrettyNumberController {
    $onChanges(changeObject) {
        if (changeObject.value) {
            this.refreshValues(this.value);
        }
    }

    refreshValues(value) {
        value = isNumeric(value) ? Number(value) : 0;

        this.normalizedValue = prettifyNumber(value, {
            addPositiveSign: this.addPositiveSign,
            omitNegativeSign: this.omitNegativeSign,
            limit: this.limit,
            preventShrink: this.preventShrink,
            decimals: this.decimals,
            pretty: this.pretty
        });

        this.formattedValue = prettifyNumber(value, {
            preventShrink: true,
            decimals: this.decimals,
            pretty: true
        });
    }
}

export default {
    selector: 'dbAPrettyNumber',
    template: template(),
    controller: PrettyNumberController,
    bindings: {
        value: '<',
        addPositiveSign: '<',
        omitNegativeSign: '<',
        limit: '<',
        preventShrink: '<',
        decimals: '<',
        pretty: '<'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/pretty-number/pretty-number.cmpt.js